import React, { useState, useContext, useEffect } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Card,
  CardHeader,
  IconButton,
  CardContent,
  Typography,
  TextField,
  LinearProgress,
} from '@mui/material';
// import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import PersonIcon from '@mui/icons-material/Person';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PeopleIcon from '@mui/icons-material/People';
import CloseIcon from '@mui/icons-material/Close';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PaymentsIcon from '@mui/icons-material/Payments';
import PictureInPictureIcon from '@mui/icons-material/PictureInPicture';
import AddIcon from '@mui/icons-material/Add';
// MUI LIST
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

// Context
import moment from 'moment';
import useCcoContext from '../context/useCcoContext';
// Components
import EngagementOptionModal from './EngagementOptionModal';
import CollectionStatusOptionModa from './CollectionStatusOptionModa';
import AttachmentStepper from './AttachmentStepper';
import AttachmentUploadModal from './AttachmentUploadModal';
// API
import {
  getMoeList,
  getCollectionStatusList,
  patchCcoUpdate,
  getCncLatestFieldEngagement,
  getCncLastClientCallOuts,
  getCncCreditAccessment,
  getCncAgingSummary,
} from '../../../api/ccoApi';

const CardContentNoPadding = styled(CardContent)(`
  padding: 0;
  &:last-child {
    padding-bottom: 0;
  }
`);

export default function CreateClientCallOutModalv2() {
  const { viewCco, setViewCco } = useContext(useCcoContext);

  const [engagementOptions, setEngagementOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  // const [statusOptions, setStatusOptions] = useState([]);
  // MODAL
  const [enagementModal, setEngagementModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [accountData, setAccountData] = useState(viewCco.row);
  const [uploadAttachmentModal, setUploadAttachmentModal] = useState(false);
  //
  const [fieldData, setFieldData] = useState({});
  const [lastCcoData, setLastCcoData] = useState({});
  const [loadingAttachment, setLoadingAttachment] = useState(false);
  const [creditData, setCreditData] = useState({
    loading: false,
    rating: 0,
    description: 'N/A',
  });
  const [agingData, setAgingData] = useState({
    loading: false,
    past_due: 0,
    current: 0,
    total_ar: 0,
    pdc: 0,
  });

  toast.dismiss();
  const handleClose = () => {
    setViewCco({ ...viewCco, toggle: false });
  };

  const creditRatingBgColor = (value) => {
    let bgValue;

    if (Math.floor(value) === 1) {
      bgValue = '#d32f2f';
    }

    if (Math.floor(value) === 2) {
      bgValue = '#ff9800';
    }

    if (Math.floor(value) === 3) {
      bgValue = '#fbff00fd';
    }

    if (Math.floor(value) === 4) {
      bgValue = '#4caf50';
    }

    if (Math.floor(value) === 5) {
      bgValue = '#2e7d32';
    }

    return bgValue;
  };
  const handleLatestFieldEngagement = async () => {
    try {
      const request = {
        account_code: viewCco.row.account_code,
        date_as_of: viewCco.row.date_schedule,
      };
      const response = await getCncLatestFieldEngagement(request);
      const { code, data } = response.data;

      if (code === '200') {
        setFieldData(data);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleLastClientCallOuts = async () => {
    try {
      const request = {
        account_code: viewCco.row.account_code,
        date_as_of: viewCco.row.date_schedule,
      };
      const response = await getCncLastClientCallOuts(request);
      const { code, data } = response.data;

      if (code === '200') {
        setLastCcoData(data);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleCreditAssesment = async () => {
    try {
      setCreditData({
        ...creditData,
        loading: true,
      });
      const request = {
        account_code: accountData?.account_code,
        date: accountData?.date_schedule,
      };

      const response = await getCncCreditAccessment(request);
      const { code, data } = response.data;

      if (code === '00000') {
        setCreditData({
          ...creditData,
          loading: false,
          rating: data[5]?.final_assessment?.rating?.rating ?? 0,
          description: data[5]?.final_assessment?.rating?.remarks ?? 'N/A',
        });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleAgingSummary = async () => {
    try {
      setAgingData({
        ...agingData,
        loading: true,
      });
      const request = {
        account_code: accountData?.account_code,
        date: accountData?.date_schedule,
        direction: 'desc',
        order_by: 'si_date',
      };

      const response = await getCncAgingSummary(request);
      const { status, results } = response.data;

      if (status === '00000') {
        const arraFect = results.find((element) => element.customer_name === 'TOTAL');

        const value = [
          /* eslint no-underscore-dangle: 0 */
          arraFect?._30days?._30days,
          arraFect?._60days?._60days,
          arraFect?._90days?._90days,
          arraFect?.over_90days?.over_90days,
        ];
        const sum = value.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

        setAgingData({
          ...agingData,
          loading: false,
          past_due: sum ?? 0,
          current: arraFect?.current?.current ?? 0,
          total_ar: arraFect?.balance,
          pdc: arraFect?.pdc,
        });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleMoeList = async () => {
    const response = await getMoeList();
    const { code, data } = response.data;

    if (code === '200') {
      setEngagementOptions(data);
    }
  };

  const handleCollectionStatusList = async () => {
    const response = await getCollectionStatusList();
    const { code, data } = response.data;

    if (code === '200') {
      setStatusOptions(data);
    }
  };

  const handleChangeMoe = async (row) => {
    toast.loading('Processing request please wait...');
    const request = {
      id: accountData?.id,
      moe_id: row.id,
    };
    const response = await patchCcoUpdate(request);
    const { code } = response.data;
    if (code === '00004') {
      toast.dismiss();
      toast.success('Successfully updated Mode of Engagement');
      setEngagementModal(false);
      setAccountData({ ...accountData, moe: row?.description });
    }
  };

  const handleChangeCollectionStatus = async (row) => {
    toast.loading('Processing request please wait...');
    const request = {
      id: accountData?.id,
      collection_status_id: row.id,
    };
    const response = await patchCcoUpdate(request);
    const { code } = response.data;
    if (code === '00004') {
      toast.dismiss();
      toast.success('Successfully updated collection status');
      setStatusModal(false);
      setAccountData({ ...accountData, collection_status: row?.description });
    }
  };
  // ISSUE AND CONCERN FORM
  const handleChange = (event, name) => {
    setAccountData({ ...accountData, [name]: event?.target?.value });
  };

  const handleSaveRemarks = async () => {
    toast.loading('Processing request please wait...');
    const request = {
      id: accountData?.id,
      discussion_remarks: accountData?.discussion_remarks,
      issues_concerns: accountData?.issues_concerns,
    };
    const response = await patchCcoUpdate(request);
    const { code } = response.data;
    if (code === '00004') {
      toast.dismiss();
      toast.success('Successfully updated remarks');
    }
  };

  const handleChangeTimeEnded = async (value) => {
    toast.loading('Processing request please wait...');
    const request = {
      id: accountData?.id,
      time_ended: moment(value).format('YYYY-MM-DD HH:mm:ss'),
    };
    const response = await patchCcoUpdate(request);
    const { code } = response.data;
    if (code === '00004') {
      toast.dismiss();
      toast.success('Successfully updated time ended');
      setAccountData({ ...accountData, time_ended: request?.time_ended });
    }
  };
  const handleChangeCollectedAmount = async () => {
    toast.loading('Processing request please wait...');
    const request = {
      id: accountData?.id,
      collection_amount: Number(accountData?.collection_amount),
    };
    const response = await patchCcoUpdate(request);
    const { code } = response.data;
    if (code === '00004') {
      toast.dismiss();
      toast.success('Successfully updated collection amount');
      setAccountData({ ...accountData, collection_amount: request?.collection_amount });
    }
  };

  useEffect(() => {
    handleLastClientCallOuts();
    handleLatestFieldEngagement();
    handleCreditAssesment();
    handleAgingSummary();
    handleMoeList();
    handleCollectionStatusList();
  }, []);
  return (
    <Dialog fullScreen open={viewCco?.toggle} onClose={handleClose}>
      <DialogTitle>
        {accountData?.account_code} - {accountData?.customer_name}
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box>
          <Card sx={{ minWidth: 275 }}>
            <CardHeader
              sx={{
                backgroundColor: '#567033ff',
                color: '#fff',
              }}
              avatar={<PersonIcon />}
              title={
                <Typography variant='button' component='h6'>
                  Account Information
                </Typography>
              }
            />
            <CardContentNoPadding>
              <Grid container>
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4} container>
                  <Grid
                    iteam
                    xs={3}
                    md={3}
                    lg={3}
                    xl={3}
                    sx={{
                      backgroundColor: '#f1d0bdff',
                    }}
                    p={1}
                  >
                    <Typography sx={{ fontWeight: 'bold' }} variant='button'>
                      Name
                    </Typography>
                  </Grid>
                  <Grid iteam xs={9} md={9} lg={9} xl={9} p={1}>
                    <Typography variant='button'>{accountData?.customer_name}</Typography>
                  </Grid>
                  <Grid
                    iteam
                    xs={3}
                    md={3}
                    lg={3}
                    xl={3}
                    sx={{
                      backgroundColor: '#f1d0bdff',
                    }}
                    p={1}
                  >
                    <Typography sx={{ fontWeight: 'bold' }} variant='button'>
                      Address
                    </Typography>
                  </Grid>
                  <Grid iteam xs={9} md={9} lg={9} xl={9} p={1}>
                    <Typography variant='button'>{accountData?.address}</Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4} container>
                  <Grid
                    iteam
                    xs={3}
                    md={3}
                    lg={3}
                    xl={3}
                    sx={{
                      backgroundColor: '#f1d0bdff',
                    }}
                    p={1}
                  >
                    <Typography sx={{ fontWeight: 'bold' }} variant='button'>
                      Contact No
                    </Typography>
                  </Grid>
                  <Grid iteam xs={9} md={9} lg={9} xl={9} p={1}>
                    <Typography variant='button'>{accountData?.customer_contact_no}</Typography>
                  </Grid>
                  <Grid
                    iteam
                    xs={3}
                    md={3}
                    lg={3}
                    xl={3}
                    sx={{
                      backgroundColor: '#f1d0bdff',
                    }}
                    p={1}
                  >
                    <Typography sx={{ fontWeight: 'bold' }} variant='button'>
                      Email
                    </Typography>
                  </Grid>
                  <Grid iteam xs={9} md={9} lg={9} xl={9} p={1}>
                    <Typography variant='button'> {accountData?.customer_email}</Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4} container>
                  <Grid
                    iteam
                    xs={3}
                    md={3}
                    lg={3}
                    xl={3}
                    sx={{
                      backgroundColor: '#f1d0bdff',
                    }}
                    p={1}
                  >
                    <Typography sx={{ fontWeight: 'bold' }} variant='button'>
                      Account Type/Channel
                    </Typography>
                  </Grid>
                  <Grid iteam xs={9} md={9} lg={9} xl={9} p={1}>
                    <Typography variant='button'> {accountData?.customer_type}</Typography>
                  </Grid>
                  <Grid iteam xs={12} md={12} lg={12} xl={12} p={1}>
                    &nbsp;
                  </Grid>
                </Grid>
              </Grid>
            </CardContentNoPadding>
          </Card>

          <Grid container mt={2}>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} mt={2} container>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                sx={{
                  backgroundColor: '#567033ff',
                  height: '50px',
                }}
                align='center'
                alignContent='center'
                alignItems='center'
              >
                <Typography
                  variant='button'
                  sx={{
                    color: '#fff',
                  }}
                >
                  Tele - Collection Log
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Card sx={{ borderRadius: 0, height: 'auto' }}>
                  <CardHeader
                    sx={{
                      backgroundColor: '#6B8D3E',
                      color: '#fff',
                    }}
                    avatar={<PeopleIcon />}
                    action={
                      <IconButton
                        aria-label='settings'
                        sx={{ color: '#fff' }}
                        onClick={() => setEngagementModal(true)}
                      >
                        <ArrowDropDownIcon />
                      </IconButton>
                    }
                    title={
                      <Typography variant='button' component='h6'>
                        Mode Of Engagement
                      </Typography>
                    }
                    align='center'
                  />
                  <CardContentNoPadding>
                    <List dense={false}>
                      <ListItem>
                        <ListItemText>{accountData?.moe}</ListItemText>
                      </ListItem>
                    </List>
                  </CardContentNoPadding>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Card sx={{ borderRadius: 0, height: 'auto' }}>
                  <CardHeader
                    sx={{
                      backgroundColor: '#6B8D3E',
                      color: '#fff',
                    }}
                    avatar={<AssignmentIcon />}
                    action={
                      <IconButton
                        aria-label='settings'
                        sx={{ color: '#fff' }}
                        onClick={() => setStatusModal(true)}
                      >
                        <ArrowDropDownIcon />
                      </IconButton>
                    }
                    title={
                      <Typography variant='button' component='h6'>
                        Status
                      </Typography>
                    }
                    align='center'
                  />
                  <CardContentNoPadding>
                    <List dense={false}>
                      <ListItem>
                        <ListItemText>{accountData?.collection_status}</ListItemText>
                      </ListItem>
                    </List>
                  </CardContentNoPadding>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card sx={{ borderRadius: 0, height: '850px' }}>
                  <CardHeader
                    sx={{
                      backgroundColor: '#6B8D3E',
                      color: '#fff',
                    }}
                    title={
                      <Typography variant='button' component='h6'>
                        Objective/Touch Point Discussed
                      </Typography>
                    }
                    action={
                      <IconButton
                        aria-label='settings'
                        sx={{ color: '#fff' }}
                        onClick={() => handleSaveRemarks()}
                      >
                        <SaveAsIcon />
                      </IconButton>
                    }
                    align='center'
                  />
                  <CardContentNoPadding>
                    <Grid
                      container
                      sx={{ backgroundColor: '#f1d0bdff', color: '#000', fontWeight: 900 }}
                      p={2}
                    >
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4} mt={2}>
                        Discussion
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4} mt={2}>
                        Remarks
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4} mt={2}>
                        Issue/Concern
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                        <TextField
                          variant='outlined'
                          onChange={(e) => handleChange(e, 'discussion_remarks')}
                          name='discussion_remarks'
                          fullWidth
                          multiline
                          rows={4}
                          maxRows={8}
                          value={accountData?.discussion_remarks}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                        <TextField
                          variant='outlined'
                          onChange={(e) => handleChange(e, 'issues_concerns')}
                          name='issues_concerns'
                          fullWidth
                          multiline
                          rows={4}
                          maxRows={8}
                          value={accountData?.issues_concerns}
                        />
                      </Grid>
                    </Grid>
                  </CardContentNoPadding>
                </Card>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} mt={2} container>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                sx={{
                  backgroundColor: '#567033ff',
                  height: '50px',
                }}
                align='center'
                alignContent='center'
                alignItems='center'
              >
                <Typography
                  variant='button'
                  sx={{
                    color: '#fff',
                  }}
                >
                  Acknowledgement
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card sx={{ borderRadius: 0 }}>
                  <CardHeader
                    sx={{
                      backgroundColor: '#6B8D3E',
                      color: '#fff',
                      height: '32px',
                    }}
                    avatar={<AccessTimeIcon />}
                    title={
                      <Typography variant='button' component='h6'>
                        Time
                      </Typography>
                    }
                    align='center'
                  />
                  <CardContentNoPadding>
                    <Grid
                      container
                      sx={{ backgroundColor: '#f1d0bdff', color: '#000', fontWeight: 900 }}
                      p={2}
                    >
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} mt={2}>
                        Time Started
                      </Grid>

                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} mt={2}>
                        Time Ended
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <DesktopTimePicker
                          // eslint-disable-next-line react/jsx-props-no-spreading
                          renderInput={(params) => <TextField {...params} fullWidth />}
                          value={accountData?.time_started}
                          readOnly
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <DesktopTimePicker
                          // eslint-disable-next-line react/jsx-props-no-spreading
                          renderInput={(params) => <TextField {...params} fullWidth />}
                          value={accountData?.time_ended}
                          onChange={(newValue) => handleChangeTimeEnded(newValue)}
                        />
                      </Grid>
                    </Grid>
                  </CardContentNoPadding>
                </Card>
                <Card sx={{ borderRadius: 0 }}>
                  <CardHeader
                    sx={{
                      backgroundColor: '#6B8D3E',
                      color: '#fff',
                      height: '32px',
                    }}
                    avatar={<PaymentsIcon />}
                    action={
                      <IconButton
                        aria-label='settings'
                        sx={{ color: '#fff' }}
                        onClick={() => handleChangeCollectedAmount()}
                      >
                        <SaveAsIcon />
                      </IconButton>
                    }
                    title={
                      <Typography variant='button' component='h6'>
                        Estimated Amount for Collection
                      </Typography>
                    }
                    align='center'
                  />
                  <CardContentNoPadding>
                    <NumericFormat
                      value={accountData?.collection_amount ?? 0}
                      prefix='₱'
                      thousandSeparator
                      customInput={TextField}
                      fullWidth
                      onChange={(e) =>
                        setAccountData({
                          ...accountData,
                          collection_amount: e.target.value?.replace(/₱|,/g, ''),
                        })
                      }
                    />
                  </CardContentNoPadding>
                </Card>
                <Card sx={{ borderRadius: 0, height: '671px' }}>
                  <CardHeader
                    sx={{
                      backgroundColor: '#6B8D3E',
                      color: '#fff',
                      height: '32px',
                    }}
                    avatar={<PictureInPictureIcon />}
                    action={
                      <IconButton
                        aria-label='settings'
                        sx={{ color: '#fff' }}
                        onClick={() => setUploadAttachmentModal(true)}
                      >
                        <AddIcon />
                      </IconButton>
                    }
                    title={
                      <Typography variant='button' component='h6'>
                        Proof of Call Outs
                      </Typography>
                    }
                    align='center'
                  />
                  <CardContent>
                    {accountData?.attachments?.length > 0 ? (
                      <AttachmentStepper
                        attachment={accountData?.attachments}
                        loadingAttachment={loadingAttachment}
                        setLoadingAttachment={setLoadingAttachment}
                      />
                    ) : (
                      'No Attachment'
                    )}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} mt={2} container>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                sx={{
                  backgroundColor: '#567033ff',
                  height: '50px',
                }}
                align='center'
                alignContent='center'
                alignItems='center'
              >
                <Typography
                  variant='button'
                  sx={{
                    color: '#fff',
                  }}
                >
                  Field Engagement
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Card sx={{ borderRadius: 0, height: '578px' }}>
                  <CardHeader
                    sx={{
                      backgroundColor: '#6B8D3E',
                      color: '#fff',
                      height: '30px',
                    }}
                    title={
                      <Typography variant='button' component='h6'>
                        Latest Field of Engagement
                      </Typography>
                    }
                    align='center'
                  />
                  <CardContentNoPadding>
                    <Grid container spacing={2} sx={{ padding: 5, fontSize: '20px' }}>
                      <Grid item md={12}>
                        Date:{' '}
                        {fieldData?.date_schedule !== null
                          ? moment(fieldData?.date_schedule).format('LL')
                          : '-'}
                      </Grid>
                      <Grid item md={12}>
                        Status: {fieldData?.status}
                      </Grid>
                      <Grid item md={12}>
                        Mode of Engagement: {fieldData?.moe}
                      </Grid>

                      <Grid item md={12}>
                        Commitment: {fieldData?.commitment_notes}
                      </Grid>
                    </Grid>
                  </CardContentNoPadding>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Card sx={{ borderRadius: 0, height: '578px' }}>
                  <CardHeader
                    sx={{
                      backgroundColor: '#6B8D3E',
                      color: '#fff',
                      height: '30px',
                    }}
                    title={
                      <Typography variant='button' component='h6'>
                        Last Client Call Outs
                      </Typography>
                    }
                    align='center'
                  />
                  <CardContentNoPadding>
                    <Grid container spacing={2} sx={{ padding: 5, fontSize: '20px' }}>
                      <Grid item md={12}>
                        Date: {moment(lastCcoData?.date_schedule).format('LL') ?? ''}
                      </Grid>
                      <Grid item md={12}>
                        Status: {lastCcoData?.collection_status}
                      </Grid>
                      <Grid item md={12}>
                        Mode of Engagement: {lastCcoData?.moe}
                      </Grid>

                      <Grid item md={12}>
                        Discussion/Remarks: {lastCcoData?.discussion_remarks}
                      </Grid>
                    </Grid>
                  </CardContentNoPadding>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Card sx={{ borderRadius: 0, height: '400px' }}>
                  <CardHeader
                    sx={{
                      backgroundColor: '#6B8D3E',
                      color: '#fff',
                      height: '30px',
                    }}
                    title={
                      <Typography variant='button' component='h6'>
                        Credit Rating
                      </Typography>
                    }
                    align='center'
                  />
                  <CardContentNoPadding>
                    {creditData?.loading ? (
                      <LinearProgress />
                    ) : (
                      <Grid container>
                        <Grid
                          item
                          md={12}
                          sx={{
                            fontSize: '40px',
                            fontWeight: 'bold',
                            borderRight: '1px solid #d8d8d8ff',
                          }}
                          p={4}
                        >
                          <Box
                            sx={{
                              backgroundColor: creditRatingBgColor(creditData?.rating),
                              paddingTop: 10,
                              paddingBottom: 10,
                              paddingLeft: 10,
                              paddingRight: 10,
                            }}
                          >
                            <Box display='flex' alignItems='center' justifyContent='center'>
                              {Math.floor(creditData?.rating)}
                            </Box>
                            <Box
                              display='flex'
                              alignItems='center'
                              justifyContent='center'
                              sx={{ fontSize: '16px' }}
                            >
                              {creditData?.description}
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    )}
                  </CardContentNoPadding>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Card sx={{ borderRadius: 0, height: '400px' }}>
                  <CardHeader
                    sx={{
                      backgroundColor: '#6B8D3E',
                      color: '#fff',
                      height: '30px',
                    }}
                    title={
                      <Typography variant='button' component='h6'>
                        Aging Of Accounts
                      </Typography>
                    }
                    align='center'
                  />
                  <CardContentNoPadding>
                    {agingData?.loading ? (
                      <LinearProgress />
                    ) : (
                      <Grid container spacing={2} sx={{ padding: 4, fontSize: '20px' }}>
                        <Grid item md={12}>
                          PAST DUE:{' '}
                          {Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(
                            agingData.past_due,
                          )}
                        </Grid>
                        <Grid item md={12}>
                          CURRENT:{' '}
                          {Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(
                            agingData.current,
                          )}
                        </Grid>
                        <Grid item md={12}>
                          TOTAL AR:{' '}
                          {Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(
                            agingData.total_ar,
                          )}
                        </Grid>
                        <Grid item md={12}>
                          TOTAL PDC:{' '}
                          {Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(
                            agingData.pdc,
                          )}
                        </Grid>
                      </Grid>
                    )}
                  </CardContentNoPadding>
                </Card>
              </Grid>
            </Grid>
          </Grid>

          {enagementModal === true ? (
            <EngagementOptionModal
              enagementModal={enagementModal}
              setEngagementModal={setEngagementModal}
              engagementOptions={engagementOptions}
              handleChangeMoe={handleChangeMoe}
            />
          ) : (
            ''
          )}

          {statusModal === true ? (
            <CollectionStatusOptionModa
              statusModal={statusModal}
              setStatusModal={setStatusModal}
              statusOptions={statusOptions}
              handleChangeCollectionStatus={handleChangeCollectionStatus}
            />
          ) : (
            ''
          )}
          {uploadAttachmentModal === true ? (
            <AttachmentUploadModal
              accountData={accountData}
              setAccountData={setAccountData}
              loadingAttachment={loadingAttachment}
              setLoadingAttachment={setLoadingAttachment}
              uploadAttachmentModal={uploadAttachmentModal}
              setUploadAttachmentModal={setUploadAttachmentModal}
            />
          ) : (
            ''
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
